import { useState, useEffect, useContext, useRef } from "react";
import { CSVLink } from 'react-csv';
import { FullScreen, useFullScreenHandle } from "react-full-screen"
import { Stack, StackItem } from "@fluentui/react";
import { MenuItem, Button, MenuList, MenuButton, Divider, Text, Body1Strong, Title3, Body1, Caption1, FluentProvider, webLightTheme, Label, Input, useId, Image, Tooltip, Badge, Textarea, Spinner } from "@fluentui/react-components";
import { AddSquare24Regular, AddSquare20Regular, Filter20Filled, FilterDismiss20Filled, ArrowClockwise20Regular, ArrowDownload20Regular, Settings20Regular, Delete24Regular, Dismiss16Regular, Delete20Regular } from "@fluentui/react-icons";
import FullScreenButton from "../../../components/fullscreen/fullScreen.component";
import OverLay from "../../../components/side_menu/overlay_side_menu.component";
import DialogBox from "../../../components/dialog/dialog.component";
import { InfoBar } from "../../../components/infoBar/infoBar.component";
import { CheckBox } from "../../../components/checkbox/checkbox_component";
import { MenuDropdown } from "../../../components/dropdown/menu.component";
import { ToastComponent } from "../../../components/toast/toast.component";
import { SearchBar } from "../../../components/searchbar/searchbar.component";
import { AutomateAppPages } from "../../../components/side_menu/InlineSidenav";
import { DataTable } from "../../../components/data_table/data_table.component";
import { Pagination } from "../../../components/pagination/pagination.component";
import { SkeletonDataTable } from "../../../components/skeleton/skeletonDataTable";
import { Breadcrumbs } from "../../../components/breadcrumbs/breadcrumbs.component";
import { DropdownComponent } from "../../../components/dropdown/dropdown.component";
import { SideMenu } from "../../../components/side_menu/inline_side_menu.component";
import { MultiselectWithTags } from "../../../components/dropdown/multiselect.component";
import { OverflowSetCustomExample } from "../../../components/side_menu/overFlowSet.component";
import { SkeletonOverlayDataTable } from "../../../components/skeleton/skeletonOverlayDataTable";
import { TroubleshooterDevice_fun } from "../../../api/troubleshoot/troubleshooterDevice_fun";
import { App_Monitored_Func } from "../../../api/app/app_monitored_func";
import { usePermissionStore } from "../../../Store/permissionStore";
import { GlobalContext } from "../../../hooks/globalContext";
import { primaryIcon, secondaryIcon, deleteIcon, lightTheme, inputsizestyle, buttonContent, overflowScroll, DynamicBoxingCSS, parentHome, wraperStyle, horizontalDivider, SubSectionResponsive, heightResponsive, tableDiv, invisible, dashboardTheme, BreadcrumbsBorder } from "../../../styles/customStyles";

interface iForms {
  id: number;
  data: {};
};

interface iChanges {
  target: {
    value: any;
    name?: any;
  };
};

interface iSubmit {
  preventDefault: () => void
};

interface iCloneRemove {
  [x: string]: any[];
};

interface iRankInput {
  cpuRank: string;
  memRank: string;
  netRank: string;
};

interface iForEach {
  display: any;
  priority: any;
  name: any;
  key: any;
};

interface iFinals {
  Category: any;
  subcategory: any;
};

interface iDataBasic {
  [x: string]: any;
};

export const Appmonitored = () => {
  const [rowID, setRowID] = useState(null);
  const [deviceList, setDeviceList] = useState(null);
  const [final_data, set_final_data] = useState(null);
  const [processName, setProcessname] = useState(null);
  const [final_data1, set_final_data1] = useState(null);
  const [leftOpenSubMenu, setleftOpenSubMenu] = useState(true);
  const [isdeletedisabled, setDeleteDisabled] = useState(true);
  const [isResetDisabled, setResetDisabled] = useState(true);
  const [loadingDevice, setLoadingDevice] = useState(true);
  const [loading, setLoading] = useState(true);
  const [isToast, setIsToast] = useState(false);
  const [isfilter, setIsFilter] = useState(false);
  const [isRefresh, setIsRefresh] = useState(false);
  const [isChecked1, setIsChecked1] = useState(false);
  const [errorToast, setErrorToast] = useState(false);
  const [overlayOpen, setOverlayOpen] = useState(false);
  const [refreshToast, setRefreshToast] = useState(false);
  const [filterMenuOpen, setFilterMenuOpen] = useState(false);
  const [saveBtnClicked, setSaveBtnClicked] = useState(false);
  const [exportBtnClicked, setExportBtnClicked] = useState(false);
  const [scoresCpuRequired, setScoreCpuRequired] = useState(false);
  const [scoresMemRequired, setScoreMemRequired] = useState(false);
  const [scoresNetRequired, setScoreNetRequired] = useState(false);
  const [deleteAppMonitored, setDeleteAppMonitored] = useState(false);
  const [monitoredOverLayData, setMonitoredOverLayData]: any = useState([]);
  const [subCategorySearchData, setSubCategorySearchData] = useState([]);
  const [subCategoryFilterData, setSubCategoryFilterData] = useState([]);
  const [categorySearchData, setCategorySearchData] = useState([]);
  const [categoryFilterData, setCategoryFilterData] = useState([]);
  const [filterColumnsData, setFilterColumnsData] = useState([]);
  const [tableColumnsData, setTableColumnsData] = useState([]);
  const [exportDetails, setExportDetails] = useState([]);
  const [uniqueSubCat, setUniqueSubCat] = useState([]);
  const [exportData, setExportData] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [uniqueCat, setUniqueCat] = useState([]);
  const [searchVal, setSearchVal] = useState("");
  const [deviceName, setDeviceName] = useState('');
  const [overlayName, setOverlayName] = useState('');
  const [toastMessage, setToastMessage] = useState('');
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPageNo, setCurrentPageNo] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [scoresFormData, setScoresFormData] = useState({});
  const [filterArray, setFilterArray] = useState<string[]>([]);
  const [dropDownValue1, setDropDownValue1] = useState<any>([]);
  const [dropDownValue2, setDropDownValue2] = useState<any>([]);
  const [cloneMemForms, setcloneMemForms] = useState<iForms[]>([]);
  const [cloneNetForms, setcloneNetForms] = useState<iForms[]>([]);
  const [spinnerLoad, setSpinnerLoad] = useState(true);
  const [selectedCategoryOptions, setSelectedCategoryOptions] = useState<any>([]);
  const [selectedSubCategoryOptions, setSelectedSubCategoryOptions] = useState<any>([]);
  const [formDataBasic, setFormDataBasic]: any = useState({
    Category: '', Subcategory: '', ApplicationName: '', ApplicationType: '', UrlPatterns: [{}], ApplicationBinaries: '',
    cpuUtilisation: [{ cpuFrom: '', cpuTo: '', cpuScore: '', cpuRank: '' }],
    memUtilisation: [{ memFrom: '', memTo: '', memScore: '', memRank: '' }],
    netUtilisation: [{ netFrom: '', netTo: '', netScore: '', netRank: '' }],
  });
  const [cloneCpuForms, setCloneCpuForms] = useState<iForms[]>([]);
  const [selectedValue, setSelectedValue] = useState('');
  const [totalOverlayRecords, setTotalOverlayRecords] = useState(0);
  const [totalOverlayPages, setTotalOverlayPages] = useState(1);
  const [allDevive, setallDevice]: any = useState(1);
  const [error, seterror] = useState(false);
  const [webEnable, setWebEnable] = useState(false);
  const [desktopEnable, setDesktopEnable] = useState(false);

  const { permissions } = usePermissionStore();

  const handle = useFullScreenHandle();
  const inputId = useId("input");
  const buttonref: any = useRef(null);
  const contextValue: any = useContext(GlobalContext);
  const tenant = contextValue.tenantName;
  const formattedUrlPatterns = formDataBasic?.UrlPatterns?.map((item: { urlpatterns: any; }) => item.urlpatterns)?.join(',');

  const handleSubmit = (e: iSubmit) => { e.preventDefault(); }

  const transformString = (data: any[], key: string) => ({
    range: data?.map((item: iDataBasic) => ({
      cw: "1", mw: "1", sc: item[`${key}Score`], to: item[`${key}To`], scw: "1", from: item[`${key}From`], rank: item[`${key}Rank`],
    })) || [],
  });
  const jsonConvert = (data: any[], key: string) => JSON.stringify(transformString(data, key), null, 2);
  const convertedDataCpustring = jsonConvert(formDataBasic?.cpuUtilisation, "cpu");
  const convertedDataMemstring = jsonConvert(formDataBasic?.memUtilisation, "mem");
  const convertedDataNetstring = jsonConvert(formDataBasic?.netUtilisation, "net");

  const handleRankInput = (userInputValue: string) => {
    const updatedFormData = ["cpuUtilisation", "memUtilisation", "netUtilisation"].reduce((acc, processName) => ({
      ...acc,
      [processName]: acc[processName].map((val: iRankInput) => ({ ...val, [`${processName.replace("Utilisation", "Rank")}`]: userInputValue }))
    }), formDataBasic);
    setFormDataBasic({ ...updatedFormData });
  };

  useEffect(() => {
    deviceList?.length > 0 && deviceName?.length === 0 && setDeviceName("All Device");
  }, [deviceList]);

  useEffect(() => {
    console.log("Checking formDataBasic: ", formDataBasic);
  }, [formDataBasic]);

  useEffect(() => {
    console.log("Checking scoresFormData: ", scoresFormData);
  }, [scoresFormData]);

  const handleInput = (value: string, processName: String, compName: string, index: number) => {
    (processName == 'cpuUtilisation' && value != '') ? setScoreCpuRequired(true) : setScoreCpuRequired(false);
    (processName == 'memUtilisation' && value != '') ? setScoreMemRequired(true) : setScoreMemRequired(false);
    (processName == 'netUtilisation' && value != '') ? setScoreNetRequired(true) : setScoreNetRequired(false);
    setFormDataBasic({
      ...formDataBasic,
      [`${processName}`]: [
        ...formDataBasic[`${processName}`].slice(0, index),
        { ...formDataBasic[`${processName}`][index], [`${compName}`]: value },
        ...formDataBasic[`${processName}`].slice(index + 1)
      ]
    });
  };

  const handleDropdownChange = (e: iChanges) => {
    setFormDataBasic((prevData: any) => {
      const { name, value } = e.target;
      if (/\d/.test(value) && (name === "Application" || name === "applicationsubcategory")) {
        return name === "Application" && value !== '' ? (seterror(true), prevData) : prevData;
      };
      const dropdownField: Record<string, any> = {
        Application: { ApplicationName: value },
        urlpatters: { UrlPatterns: value },
        applicationbinaries: { ApplicationBinaries: value },
        applicationsubcategory: { Subcategory: value }
      };
      return dropdownField[name] ? { ...prevData, ...dropdownField[name] } : {
        Category: '', Subcategory: '', ApplicationName: '', ApplicationType: '', ApplicationBinaries: '', UrlPatterns: [{}],
        cpuUtilisation: [{ cpuFrom: '', cpuTo: '', cpuScore: '', cpuRank: '' }],
        memUtilisation: [{ memFrom: '', memTo: '', memScore: '', memRank: '' }],
        netUtilisation: [{ netFrom: '', netTo: '', netScore: '', netRank: '' }]
      };
    });
  };

  const handleUserSearchInput = (e: iChanges, type = '') => {
    const { value } = e.target;
    if (!value || /\d/.test(value)) { return false; };
    const filters = (list: string[]) => list.filter((item) => item.length > 0 && item.toLocaleLowerCase().includes(value.toLocaleLowerCase()));
    const primary = setCategorySearchData(filters(uniqueCat).length ? filters(uniqueCat) : [value]);
    const secondary = setSubCategorySearchData(filters(uniqueSubCat).length ? filters(uniqueSubCat) : [value]);
    return (type === "category") ? primary : (type === "subCategory") ? secondary : null;
  };

  const handleCheckboxChange = (type: 'Web' | 'Desktop') => (e: any) => {
    setFormDataBasic((prevData: any) => {
      const { checked } = e.target;
      return { ...prevData, ApplicationType: checked ? type : prevData[type === 'Web' ? 'Desktop' : 'Web'] ? prevData.ApplicationType : '' };
    });
  };
  const handleWebCheckbox = handleCheckboxChange('Web');
  const handleDesktopCheckbox = handleCheckboxChange('Desktop');

  const handleChange = (name: any, val: any) => {
    // Handle multi-select dropdowns (e.g., ApplicationType, UrlPatterns, ApplicationBinaries)
    // Extract selected values as an array and update corresponding field in formDataBasic Example: { ApplicationType: [], UrlPatterns: [] }
    // setFormDataBasic((prevData) => ({ ...prevData, [name]: Array.from(e.target.selectedOptions, ({ value }: any) => value) }));
    return name === 'applicationtype' ? setIsChecked1(!isChecked1) : setFormDataBasic((prevData: any) => ({ ...prevData, [name]: val }));
  };

  const inputChange = (e: iChanges) => {
    const { name, value } = e.target;
    const { alpha, alphaNumeric, numeric } = { alpha: /^[A-Za-z ]*$/, alphaNumeric: /^[A-Za-z0-9 ]*$/, numeric: /^[0-9]*$/ };
    const regexMap: Record<string, RegExp> = {
      Category: alpha, Subcategory: alpha, Name: alpha, URL: alphaNumeric, "Desktop Binaries": alphaNumeric, Score: numeric,
    };
    return (name === "filter" && dropDownValue1 in regexMap && regexMap[dropDownValue1].test(value)) ? setDropDownValue2(value) : null;
  };

  const handleFilterArray = () => {
    setFilterArray([...filterArray, dropDownValue1 + " : " + dropDownValue2])
    setIsFilter(true);
    setLoading(true);
    setDropDownValue1('');
    setDropDownValue2('');
  };

  const handleCloseFilter = (index: number) => {
    console.log("Clicked...");
    setFilterArray(filterArray.filter((_, itemIndex) => itemIndex !== index));
    setLoading(true);
  };

  useEffect(() => {
    (filterArray.length > 0) ? setResetDisabled(false) : setResetDisabled(true);
  }, [filterArray]);

  const handleAddClone = (_index: number, processName: string) => {
    const { cpuUtilisation, memUtilisation, netRank } = formDataBasic || {};
    const cloneContent: Record<string, any> = {
      cpuUtilisation: { cpuFrom: '', cpuTo: '', cpuScore: '', cpuRank: cpuUtilisation?.[0]?.cpuRank },
      memUtilisation: { memFrom: '', memTo: '', memScore: '', memRank: memUtilisation?.[0]?.cpuRank },
      netUtilisation: { netFrom: '', netTo: '', netScore: '', netRank: netRank?.[0]?.cpuRank },
      UrlPatterns: {},
    };
    (formDataBasic[processName]?.length <= 3) && setFormDataBasic((prev: iDataBasic) => ({
      ...prev, [processName]: [...(prev[processName] || []), cloneContent[processName] || {}],
    }));
  };

  const handleRemoveClone = (id: number, processName: string) => {
    return setFormDataBasic((prev: iCloneRemove) => ({ ...prev, [processName]: prev[processName]?.filter((_, i) => i !== id) || [] }))
  };

  const handleMemAddClone = () => cloneMemForms.length < 3 && setcloneMemForms([...cloneMemForms, { id: Date.now(), data: {} }]);
  const handleRemoveMemClone = (id: number) => { setcloneMemForms(cloneMemForms.filter((formMem) => formMem.id !== id)); };

  const handleNetAddClone = () => cloneNetForms.length < 3 && setcloneNetForms([...cloneNetForms, { id: Date.now(), data: {} }]);
  const handleRemoveNetClone = (id: number) => { setcloneNetForms(cloneNetForms.filter((formNet) => formNet.id !== id)); };

  useEffect(() => {
    deviceName.length > 0 && setScoresFormData({ ...scoresFormData, [`${deviceName}`]: { cpuUtilisation: formDataBasic?.cpuUtilisation, memUtilisation: formDataBasic?.memUtilisation, netUtilisation: formDataBasic?.netUtilisation } });
  }, [formDataBasic]);

  useEffect(() => {
    if (deviceName.length > 0) {
      if (scoresFormData[deviceName] !== undefined) {
        if (Object.keys(scoresFormData[deviceName]).length > 0) {
          setFormDataBasic({ ...formDataBasic, cpuUtilisation: scoresFormData[deviceName]?.cpuUtilisation, memUtilisation: scoresFormData[deviceName]?.memUtilisation, netUtilisation: scoresFormData[deviceName]?.netUtilisation });
        }
      } else {
        setFormDataBasic({
          ...formDataBasic,
          cpuUtilisation: [{ cpuFrom: '', cpuTo: '', cpuScore: '', cpuRank: '' }],
          memUtilisation: [{ memFrom: '', memTo: '', memScore: '', memRank: '' }],
          netUtilisation: [{ netFrom: '', netTo: '', netScore: '', netRank: '' }],
        });
      }
    }
    setTimeout(() => {
      setLoadingDevice(false);
    }, 800);
  }, [deviceName]);

  useEffect(() => {
    var tableColumns: any[] = [];
    var filterColumns: any[] = [];
    contextValue?.tableColumnsData?.Apps?.App_monitor.forEach(({ display, priority, name, key }: iForEach) => {
      const { table, filter } = display;
      if (table.toLocaleLowerCase() === "yes" && priority >= 0) {
        tableColumns[priority] = ({ key: key, label: <Body1Strong> {name} </Body1Strong> });
      };
      if (filter.toLocaleLowerCase() === "yes") {
        filterColumns.push({ key: key, label: <Caption1> {name} </Caption1> });
      };
    });
    setTableColumnsData(tableColumns);
    setFilterColumnsData(filterColumns);
    contextValue.setManageViewDropDownData(contextValue?.tableColumnsData?.Apps?.App_monitor.filter(({ priority }) => priority >= 0));
    contextValue.setManageViewPageDetails({ module: "Apps", page: "App_monitor" });
  }, [contextValue.tableColumnsData]);

  useEffect(() => {
    uniqueCat.length && setCategorySearchData(uniqueCat);
    overlayOpen && selectedCategoryOptions.length &&
      setFormDataBasic((prevData: any) => /\d/.test(selectedCategoryOptions[0])
        ? prevData : { ...prevData, Category: selectedCategoryOptions[0] }
      );
  }, [selectedCategoryOptions]);

  useEffect(() => {
    uniqueSubCat.length && setSubCategorySearchData(uniqueSubCat);
    overlayOpen && selectedSubCategoryOptions.length &&
      setFormDataBasic((prevData: any) => /\d/.test(selectedSubCategoryOptions[0])
        ? prevData : { ...prevData, Subcategory: selectedSubCategoryOptions[0] }
      );
  }, [selectedSubCategoryOptions]);

  useEffect(() => {
    var tempExportData: any = [];
    exportDetails?.length > 0 && exportDetails.map(({ Category, subcategory, MetricDesc, UrlPatters, SpecificInfo }) => {
      tempExportData.push({
        'Category': Category, "Sub category": subcategory, 'Name': MetricDesc, "Url Pattern": UrlPatters, "Desktop Pattern": SpecificInfo
      });
    });
    setExportData(tempExportData);
  }, [exportDetails]);

  useEffect(() => {
    exportData.length > 0 && document.getElementById('csv-export-link')?.click();
  }, [exportData]);

  useEffect(() => {
    const newData = (() => {
      const newUniqueCategory: any[] = [];
      const newUniqueSubCategory: any[] = [];
      final_data.forEach(({ Category, subcategory }: iFinals) => {
        Category?.length && !newUniqueCategory.includes(Category) && newUniqueCategory.push(Category);
        subcategory?.length && !newUniqueSubCategory.includes(subcategory) && newUniqueSubCategory.push(subcategory);
      });
      setUniqueCat(newUniqueCategory);
      setCategorySearchData(newUniqueCategory);
      setUniqueSubCat(newUniqueSubCategory);
      setSubCategorySearchData(newUniqueSubCategory);
    });
    (final_data?.length) ? newData() : setUniqueCat([]);
  }, [final_data]);

  useEffect(() => {
    var tempTableData: any = []; // Data table values append code starts here
    console.log("Final data before: ", final_data);

    (final_data !== undefined && final_data !== null && final_data.length > 0)
      ? final_data?.map((val: any, i: any) => {
        const { id, subcategory, MetricDesc, UrlPatters, SpecificInfo, MetricName, Category  } = val;

        const displayType = MetricName === "Network Response" ? "Network Utilisation" :  MetricName === "Process Memory Usage" ? "Memory Utilisation" : MetricName === "Process CPU Usage" ? "CPU Utilisation" : "";

        const handleCheckboxClick = (e: any) => {
          setSpinnerLoad(true);
          setRowID(id);
          setOverlayOpen(true);
          setOverlayName('editMonitoredApp');
          setProcessname(MetricName);
        };

        const texts = (value: any) => <Caption1> {value ?? "-"} </Caption1>;
        const renderCategoryButton = (names, clicks, isPermit) => {
          const openButton = (
            <Button shape="circular" id="ButtonHover" appearance="transparent" size="small" onClick={isPermit ? clicks : undefined} style={buttonContent}>
              {names}
            </Button>
          );
          return isPermit ? openButton : (
            <Tooltip withArrow content="You do not have access" relationship="description" positioning="above">
              {openButton}
            </Tooltip>
          );
        };

        const hasPermit = (isPermit: boolean) => ({
          ...(isPermit ? {} : { checkbox: "hide" }),
          id: id,
          subcategory: { label: texts(subcategory), status: "" },
          name: { label: renderCategoryButton(MetricDesc, handleCheckboxClick, isPermit) },
          type: { label: texts(displayType) },
          url_pattern: { label: texts(UrlPatters) },
          desktop_pattern: { label: texts(SpecificInfo) },
          category: { id: i, label: texts(Category) }
        });

        const permit = (permissions.includes("all") || permissions.includes("appMonitored_Fullaccess"));

        return tempTableData.push(permit ? hasPermit(true) : hasPermit(false));
      }) : (tempTableData = []);

    tempTableData.length > 0 ? setTableData(tempTableData) : setTableData([]);
    console.log("Final data after: ", final_data);
    final_data !== undefined && final_data !== null && setLoading(false);
  }, [final_data, permissions]);

  useEffect(() => {
    setCategoryFilterData(uniqueCat.map((item) => ({ key: item, label: <Caption1> {item} </Caption1> })));
  }, [uniqueCat]);

  useEffect(() => {
    setSubCategoryFilterData(uniqueSubCat.map((item) => ({ key: item, label: <Caption1> {item} </Caption1> })));
  }, [uniqueSubCat]);

  const asterix = <Image src="/Dashboard/image/required.svg" alt="Required" />;
  const space = <span style={invisible}>{asterix}</span>;
  const empty = <StackItem> <Text /> </StackItem>;

  const InfoDesc = ({ desc }) => {
    const content = {
      basicInfos: "Enter the application details to monitor CPU, memory, network, and application usage. URL monitoring is applicable only for Google Chrome and Microsoft Edge. If the application is one of these, enter the URL details for monitoring.",
      scoreInfos: "Enter the scores for the application, based on which CPU, memory, and network usage scores will be allocated.",
      inform: "Apps Monitored is a module that allows users to configure monitoring for specific applications to track CPU, memory, and network usage, and to set scores based on usage. To enable monitoring, the configured apps must be linked to a tenant or device collection in the Data Collection module under Manage."
    };
    return <InfoBar showSpaces={true} title={content[desc]} />;
  };

  const FormDesc = ({ desc }) => {
    const content = {
      categoryDesc: "Choose or add a category under which you want to monitor this app.",
      subCategoryDesc: "Choose or add a sub-category under which you want to monitor this app.",
      binaryDesc: "Enter the application's executable file name, such as chrome.exe. The binary name is case-sensitive.",
      patternDesc: "URL monitoring is applicable only for Google Chrome and Microsoft Edge. Enter the generic URL name, such as 'nanoheal'. Any URL containing 'nanoheal' will be monitored. For example, both 'https://www.nanoheal.com/products-1' and 'https://www.nanoheal.com/platform' will be monitored. Multiple URLs can be entered by clicking the '+'. Enter '*' to monitor all URLs. The URL name is not case-sensitive."
    };
    return <Caption1 content="justify"> {content[desc]} </Caption1>;
  };

  useEffect(() => {
    const addTitle = <Title3> Create an Applications to be monitored </Title3>;
    const editTitle = <Title3> Edit {formDataBasic?.ApplicationName} </Title3>;

    const AddBasicTab = (write = true) => {
      const dropFields = [
        { gap: 44, label: "Application Category", state: selectedCategoryOptions, setState: setSelectedCategoryOptions, options: categorySearchData, info: "categoryDesc", key: "category", place: "category", tags: formDataBasic?.Category },
        { gap: 24, label: "Application Subcategory", state: selectedSubCategoryOptions, setState: setSelectedSubCategoryOptions, options: subCategorySearchData, info: "subCategoryDesc", key: "subCategory", place: "sub category", tags: formDataBasic?.Subcategory }
      ];

      const inputFields = [
        { gap: 63, label: "Application Name", name: "Application", value: formDataBasic?.ApplicationName, type: "text", info: null, place: "Enter application name" },
        { gap: 61, label: "Application Binary", name: "applicationbinaries", value: formDataBasic?.ApplicationBinaries, type: "text", info: "binaryDesc", place: "Example: chrome.exe" }
      ];

      const dropSection = dropFields.map(({ label, state, setState, options, info, key, place, gap, tags }, index) => (
        <Stack key={index} horizontal tokens={{ padding: 10, childrenGap: gap }}>
          <Body1> {label}{write ? asterix : space} </Body1>
          <Stack tokens={{ childrenGap: 5 }}>
            {write
              ? <MultiselectWithTags style={inputsizestyle} options={options} setSelectedOptions={setState} selectedOptions={state} multi={false} tag={state?.length > 0} placeholder={`Select the ${place}`} onChange={(e) => handleUserSearchInput(e, key)} required disabled={!write} />
              : <Badge appearance="filled" color="informative" size="large"> {tags} </Badge>
            }
            {write && <FormDesc desc={info} />}
          </Stack>
        </Stack>
      ));

      const inputSection = inputFields.map(({ label, name, value, info, gap, place }, index) => (
        <Stack key={index} horizontal tokens={{ padding: 10, childrenGap: gap }}>
          <Body1> {label}{write ? asterix : space} </Body1>
          <Stack tokens={{ childrenGap: 5 }}>
            <Input style={inputsizestyle} onChange={handleDropdownChange} name={name} value={value} placeholder={place} type="text" required disabled={!write} />
            {write && <FormDesc desc={info} />}
          </Stack>
        </Stack>
      ));

      const cloneSection = formDataBasic?.UrlPatterns?.map((form, i) => (
        <Stack horizontal tokens={{ padding: 10 }} key={i}>
          {empty}
          <StackItem>
            <Stack tokens={{ padding: 1 }}>
              <Stack horizontal tokens={{ childrenGap: 20 }}>
                <StackItem align="center">
                  <Stack horizontal tokens={{ childrenGap: 9.75 }}>
                    {i === 0 ? <Body1> URL Patterns </Body1> : empty}
                    {i !== 0 && (<>{Array(3).fill(empty)}<Stack horizontal tokens={{ childrenGap: 15 }}>{Array(3).fill(empty)}</Stack>{empty}</>)}
                    {Array(10).fill(empty)}
                    <Stack>
                      <Label size="small" htmlFor={`input-${i}`} />
                      <Input style={inputsizestyle} placeholder="Enter URL pattern" id={`input-${i}`} value={form.urlpatterns} onChange={(e) => handleInput(e.target.value, 'UrlPatterns', 'urlpatterns', i)} disabled={!write} />
                    </Stack>
                    {write && (i === 0
                      ? <AddSquare24Regular {...primaryIcon} onClick={() => handleAddClone(i + 1, 'UrlPatterns')} />
                      : <Delete24Regular {...deleteIcon} onClick={() => handleRemoveClone(i, 'UrlPatterns')} />)}
                  </Stack>
                </StackItem>
              </Stack>
            </Stack>
          </StackItem>
        </Stack>
      ));

      const extraForm = () => {
        const extraField = [
          { label: "Web", stateSetter: setWebEnable, oppositeSetter: setDesktopEnable, handler: handleWebCheckbox },
          { label: "Desktop", stateSetter: setDesktopEnable, oppositeSetter: setWebEnable, handler: handleDesktopCheckbox }
        ];
        return (
          <>
            <Stack horizontal tokens={{ childrenGap: 116, padding: 10 }}>
              <Body1> Description </Body1>
              <Textarea onChange={handleDropdownChange} name="description" value={formDataBasic?.Description} />
            </Stack>
            <Stack horizontal tokens={{ childrenGap: 77, padding: 10 }}>
              <Body1> Application Type </Body1>
              <StackItem shrink grow>
                {extraField.map(({ label, stateSetter, oppositeSetter, handler }) => {
                  const clickBox = () => { stateSetter(true); oppositeSetter(false); };
                  const changeBox = (e) => handler(e);
                  return <CheckBox key={label} label={label} checked={formDataBasic?.[label]} onChange={changeBox} onClick={clickBox} />
                })}
              </StackItem>
            </Stack>
          </>
        )
      };

      return (
        <>
          {dropSection}
          {inputSection}
          {/* {extraForm()} */}
          {cloneSection}
          {write && (
            <Stack horizontal tokens={{ childrenGap: 28.25 }} style={{ position: 'relative', top: -5 }}>
              {Array(7).fill(empty)}
              <StackItem> <FormDesc desc="patternDesc" /> </StackItem>
            </Stack>
          )}
        </>
      );
    };

    const AddScoresTab = (write = true) => {
      const allDevicesData = () => deviceList?.map(({ classificationName }) => {
        const handleDevice = () => {
          setDeviceName(classificationName);
          setallDevice(false);
          setLoadingDevice(true);
        };
        return (
          <StackItem>
            <StackItem onClick={handleDevice}>
              <FluentProvider theme={(deviceName !== "All Device" && deviceName === classificationName) ? lightTheme : undefined}>
                <MenuItem> <Body1> {classificationName} </Body1> </MenuItem>
              </FluentProvider>
            </StackItem>
          </StackItem>
        )
      });

      const utilisationData = () => {
        const fields = [
          { uType: 'cpu', id: 'cpuUtilisation', label: 'Process Cpu Utilisation', requires: scoresCpuRequired },
          { uType: 'mem', id: 'memUtilisation', label: 'Process Mem Utilisation', requires: scoresMemRequired },
          { uType: 'net', id: 'netUtilisation', label: 'Process Network Utilisation', requires: scoresNetRequired }
        ];
        return (
          <Stack tokens={{ childrenGap: 15 }}>
            {fields.map(({ uType, id, label, requires }) => (
              <Stack key={id} tokens={{ childrenGap: 10 }}>
                <Body1> {label} </Body1>
                <StackItem>
                  {formDataBasic?.[id]?.map((formItem, i) => (
                    <Stack horizontal enableScopedSelectors key={formItem.id || i} tokens={{ childrenGap: 10, padding: i > 0 ? '10px 0' : '1px' }}>
                      {[`${uType}From`, `${uType}To`, `${uType}Score`].map((field, index) => (
                        <StackItem key={index} align="auto">
                          <Label size="small" htmlFor={inputId} />
                          <Input size="small" type="number" id={inputId} value={formItem[field]} required={requires} placeholder={field.replace(uType, '')} onChange={(e) => handleInput(e.target.value, id, field, i)} disabled={!write} />
                        </StackItem>
                      ))}
                      {write && (
                        <StackItem align="center">
                          {i === 0 ? <AddSquare24Regular {...primaryIcon} onClick={() => handleAddClone(i + 1, id)} />
                            : <Delete24Regular {...deleteIcon} onClick={() => handleRemoveClone(i, id)} />}
                        </StackItem>)}
                    </Stack>
                  ))}
                </StackItem>
              </Stack>
            ))}
          </Stack>
        );
      };

      const scoreForm = () => {
        const handleScores = () => setFormDataBasic({
          Category: '', Subcategory: '', ApplicationName: '', ApplicationType: '', ApplicationBinaries: '',
          UrlPatterns: [{}],
          cpuUtilisation: [{ cpuFrom: '', cpuTo: '', cpuScore: '', cpuRank: '' }],
          memUtilisation: [{ memFrom: '', memTo: '', memScore: '', memRank: '' }],
          netUtilisation: [{ netFrom: '', netTo: '', netScore: '', netRank: '' }],
        });

        const handleRank = (e) => handleRankInput(e.target.value);
        const valueRank = scoresFormData?.[deviceName]?.cpuUtilisation?.[0]?.cpuRank;

        const rankData = (
          <Stack tokens={{ childrenGap: 5 }}>
            <Body1> Rank{write ? asterix : space} </Body1>
            <StackItem>
              <Label size="small" htmlFor={inputId} />
              <Input size="small" type="number" id={inputId} value={valueRank} required={true} placeholder="Rank" onChange={handleRank} disabled={!write} />
            </StackItem>
          </Stack>
        );

        return loadingDevice ? <SkeletonOverlayDataTable /> : (
          <StackItem>
            <FluentProvider theme={dashboardTheme}>
              <Stack tokens={{ childrenGap: 10 }}>
                {write && (
                  <StackItem onClick={handleScores}>
                    <Button shape="circular" appearance="primary" size="small"> <Caption1> Reset </Caption1> </Button>
                  </StackItem>
                )}
                {rankData}
                <Text />
                <Body1Strong> Application Scores{write && asterix} </Body1Strong>
                {utilisationData()}
              </Stack>
            </FluentProvider>
          </StackItem>
        );
      };

      return (
        <form autoComplete="off" id="myFormAppmonitored" onSubmit={handleSubmit} style={heightResponsive}>
          {write && <InfoDesc desc="scoreInfos" />}
          <Stack horizontal tokens={{ childrenGap: 40 }} style={tableDiv}>
            <StackItem style={overflowScroll}>
              <Stack>
                <Body1Strong> Select&nbsp;Classification </Body1Strong>
                <Stack tokens={{ childrenGap: 10 }}>
                  {empty}
                  <StackItem> <Divider style={horizontalDivider} /> </StackItem>
                </Stack>
                <StackItem onClick={() => { setDeviceName('All Device'); setLoadingDevice(true); }}>
                  <FluentProvider theme={(deviceName === "All Device" || deviceName === "") ? lightTheme : undefined}>
                    <MenuItem> All Device </MenuItem>
                  </FluentProvider>
                </StackItem>
                {allDevicesData()}
              </Stack>
            </StackItem>
            {scoreForm()}
          </Stack>
          {write && <Button shape="circular" style={{ display: "none" }} ref={buttonref} type="submit"> Validate </Button>}
        </form>
      );
    };

    const EditBasicTab = (write = true) => {
      const dropFields = [
        { gap: 44, label: "Application Category", state: selectedCategoryOptions, setState: setSelectedCategoryOptions, options: categorySearchData, info: "categoryDesc", key: "category", place: "category", tags: formDataBasic?.Category },
        { gap: 24, label: "Application Subcategory", state: selectedSubCategoryOptions, setState: setSelectedSubCategoryOptions, options: subCategorySearchData, info: "subCategoryDesc", key: "subCategory", place: "sub category", tags: formDataBasic?.Subcategory }
      ];

      const inputFields = [
        { gap: 63, label: "Application Name", name: "Application", value: formDataBasic?.ApplicationName, type: "text", info: null, place: "Enter application name" },
        { gap: 61, label: "Application Binary", name: "applicationbinaries", value: formDataBasic?.ApplicationBinaries, type: "text", info: "binaryDesc", place: "Example: chrome.exe" }
      ];

      const dropSection = dropFields.map(({ label, state, setState, options, info, key, place, gap, tags }, index) => (
        <Stack key={index} horizontal tokens={{ padding: 10, childrenGap: gap }}>
          <Body1> {label}{write ? asterix : space} </Body1>
          <Stack tokens={{ childrenGap: 5 }}>
            {write
              ? <MultiselectWithTags style={inputsizestyle} options={options} setSelectedOptions={setState} selectedOptions={state} multi={false} tag={state?.length > 0} placeholder={`Select the ${place}`} onChange={(e) => handleUserSearchInput(e, key)} required={state.length > 0 ? false : true} />
              : <Badge appearance="filled" color="informative" size="large"> {tags} </Badge>
            }
            {write && <FormDesc desc={info} />}
          </Stack>
        </Stack>
      ));

      const inputSection = inputFields.map(({ label, name, value, info, gap, place }, index) => (
        <Stack key={index} horizontal tokens={{ padding: 10, childrenGap: gap }}>
          <Body1> {label}{write ? asterix : space} </Body1>
          <Stack tokens={{ childrenGap: 5 }}>
            <Input style={inputsizestyle} onChange={handleDropdownChange} name={name} value={value} placeholder={place} type="text" required />
            {write && <FormDesc desc={info} />}
          </Stack>
        </Stack>
      ));

      const cloneSection = formDataBasic?.UrlPatterns?.map((form, i) => (
        <Stack horizontal tokens={{ padding: 10 }} key={i}>
          {empty}
          <StackItem>
            <Stack tokens={{ padding: 1 }}>
              <Stack horizontal tokens={{ childrenGap: 20 }}>
                <StackItem align="center">
                  <Stack horizontal tokens={{ childrenGap: 9.75 }}>
                    {i === 0 ? <Body1> URL Patterns </Body1> : empty}
                    {i !== 0 && (<>{Array(3).fill(empty)}<Stack horizontal tokens={{ childrenGap: 15 }}>{Array(3).fill(empty)}</Stack>{empty}</>)}
                    {Array(10).fill(empty)}
                    <Stack>
                      <Label size="small" htmlFor={`input-${i}`} />
                      <Input style={inputsizestyle} placeholder="Enter URL pattern" id={`input-${i}`} value={form.urlpatterns} onChange={(e) => handleInput(e.target.value, 'UrlPatterns', 'urlpatterns', i)} />
                    </Stack>
                    {write && (i === 0
                      ? <AddSquare24Regular {...primaryIcon} onClick={() => handleAddClone(i + 1, 'UrlPatterns')} />
                      : <Delete24Regular {...deleteIcon} onClick={() => handleRemoveClone(i, 'UrlPatterns')} />)}
                  </Stack>
                </StackItem>
              </Stack>
            </Stack>
          </StackItem>
        </Stack>
      ));

      const extraForm = () => {
        const extraField = [
          { label: "Web", stateSetter: setWebEnable, oppositeSetter: setDesktopEnable, handler: handleWebCheckbox },
          { label: "Desktop", stateSetter: setDesktopEnable, oppositeSetter: setWebEnable, handler: handleDesktopCheckbox }
        ];
        return (
          <>
            <Stack horizontal tokens={{ childrenGap: 116, padding: 10 }}>
              <Body1> Description </Body1>
              <Textarea onChange={handleDropdownChange} name="description" value={formDataBasic?.Description} />
            </Stack>
            <Stack horizontal tokens={{ childrenGap: 77, padding: 10 }}>
              <Body1> Application Type </Body1>
              <StackItem shrink grow>
                {extraField.map(({ label, stateSetter, oppositeSetter, handler }) => {
                  const clickBox = () => { stateSetter(true); oppositeSetter(false); };
                  const changeBox = (e) => handler(e);
                  return <CheckBox key={label} label={label} checked={formDataBasic?.[label]} onChange={changeBox} onClick={clickBox} />
                })}
              </StackItem>
            </Stack>
          </>
        )
      };

      return (
        <>
          {dropSection}
          {inputSection}
          {cloneSection}
          {/* {extraForm()} */}
          {write && (
            <Stack horizontal tokens={{ childrenGap: 28.25 }} style={{ position: 'relative', top: -5 }}>
              {Array(7).fill(empty)}
              <StackItem> <FormDesc desc="patternDesc" /> </StackItem>
            </Stack>
          )}
        </>
      )
    };

    const EditScoresTab = (write = true) => {
      const allDevicesData = () => deviceList?.map(({ classificationName }) => {
        const handleDevice = () => {
          setDeviceName(classificationName);
          setallDevice(false);
          setLoadingDevice(true);
        };
        return (
          <StackItem>
            <StackItem onClick={handleDevice}>
              <FluentProvider theme={(deviceName !== "All Device" && deviceName === classificationName) ? lightTheme : undefined}>
                <MenuItem> <Body1> {classificationName} </Body1> </MenuItem>
              </FluentProvider>
            </StackItem>
          </StackItem>
        )
      });

      const utilisationData = () => {
        const fields = [
          { uType: 'cpu', id: 'cpuUtilisation', label: 'Process Cpu Utilisation', requires: scoresCpuRequired, pro: 'CPU' },
          { uType: 'mem', id: 'memUtilisation', label: 'Process Mem Utilisation', requires: scoresMemRequired, pro: 'Memory' },
          { uType: 'net', id: 'netUtilisation', label: 'Process Network Utilisation', requires: scoresNetRequired, pro: 'Network' }
        ];
        return (
          <Stack tokens={{ childrenGap: 15 }}>
            {fields.map(({ uType, id, label, requires, pro }) => /* processName.includes(pro) && */(
              <Stack key={id} tokens={{ childrenGap: 10 }}>
                <Body1> {label} </Body1>
                <StackItem>
                  {formDataBasic?.[id]?.map((formItem, i) => (
                    <Stack horizontal enableScopedSelectors key={formItem.id || i} tokens={{ childrenGap: 10, padding: i > 0 ? '10px 0' : '1px' }}>
                      {[`${uType}From`, `${uType}To`, `${uType}Score`].map((field, index) => (
                        <StackItem key={index} align="auto">
                          <Label size="small" htmlFor={inputId} />
                          <Input size="small" type="number" id={inputId} value={formItem[field]} required={requires} placeholder={field.replace(uType, '')} onChange={(e) => handleInput(e.target.value, id, field, i)} disabled={!write} />
                        </StackItem>
                      ))}
                      {write && (
                        <StackItem align="center">
                          {i === 0 ? <AddSquare24Regular {...primaryIcon} onClick={() => handleAddClone(i + 1, id)} />
                            : <Delete24Regular {...deleteIcon} onClick={() => handleRemoveClone(i, id)} />}
                        </StackItem>)}
                    </Stack>
                  ))}
                </StackItem>
              </Stack>
            ))}
          </Stack>
        )
      };

      const scoreForm = () => {
        const handleScores = () => setFormDataBasic({
          Category: '', Subcategory: '', ApplicationName: '', ApplicationType: '', ApplicationBinaries: '',
          UrlPatterns: [{/* urlpattern: '' */ }],
          cpuUtilisation: [{ cpuFrom: '', cpuTo: '', cpuScore: '', cpuRank: '' }],
          memUtilisation: [{ memFrom: '', memTo: '', memScore: '', memRank: '' }],
          netUtilisation: [{ netFrom: '', netTo: '', netScore: '', netRank: '' }],
        });

        const handleRank = (e) => handleRankInput(e.target.value);
        const valueRank = scoresFormData?.[deviceName]?.cpuUtilisation?.[0]?.cpuRank;

        const rankData = (
          <Stack tokens={{ childrenGap: 5 }}>
            <Body1> Rank{write ? asterix : space} </Body1>
            <StackItem>
              <Label size="small" htmlFor={inputId} />
              <Input size="small" type="number" id={inputId} value={valueRank} required={true} placeholder="Rank" onChange={handleRank} disabled={!write} />
            </StackItem>
          </Stack>
        );

        return loadingDevice ? <SkeletonOverlayDataTable /> : (
          <StackItem>
            <FluentProvider theme={dashboardTheme}>
              <Stack tokens={{ childrenGap: 10 }}>
                {write && (
                  <StackItem onClick={handleScores}>
                    <Button shape="circular" appearance="primary" size="small"> <Caption1> Reset </Caption1> </Button>
                  </StackItem>
                )}
                {rankData}
                <Text />
                <Body1Strong> Application Scores{write && asterix} </Body1Strong>
                {utilisationData()}
              </Stack>
            </FluentProvider>
          </StackItem>
        );
      };

      return (
        <form autoComplete="off" id="myFormAppmonitored" onSubmit={handleSubmit} style={heightResponsive}>
          {write && <InfoDesc desc="scoreInfos" />}
          <Stack horizontal tokens={{ childrenGap: 40 }} style={tableDiv}>
            <StackItem style={overflowScroll}>
              <Stack>
                <Body1Strong> Select&nbsp;Classification </Body1Strong>
                <Stack tokens={{ childrenGap: 10 }}>
                  {empty}
                  <StackItem> <Divider style={horizontalDivider} /> </StackItem>
                </Stack>
                <StackItem onClick={() => { setDeviceName('All Device'); setLoadingDevice(true); }}>
                  <FluentProvider theme={(deviceName === "All Device" || deviceName === "") ? lightTheme : undefined}>
                    <MenuItem> All Device </MenuItem>
                  </FluentProvider>
                </StackItem>
                {allDevicesData()}
              </Stack>
            </StackItem>
            {scoreForm()}
          </Stack>
          {write && <Button shape="circular" style={{ display: "none" }} ref={buttonref} type="submit"> Validate </Button>}
        </form>
      );
    };

    const addBasics = () => (
      <form autoComplete="off" id="myFormAppmonitored" onSubmit={handleSubmit}>
        <InfoDesc desc="basicInfos" />
        {AddBasicTab(true)}
        <Button shape="circular" ref={buttonref} style={{ display: "none" }} type="submit"> Validate </Button>
      </form>
    );

    const addScores = () => (<> {AddScoresTab(true)} </>);

    const addReviews = () => (
      <Stack tokens={{ childrenGap: 20 }}>
        {AddBasicTab(false)}
        {AddScoresTab(false)}
      </Stack>
    );

    const editBasics = () => (
      spinnerLoad ?
        <Stack horizontal verticalAlign="center" horizontalAlign="center" style={DynamicBoxingCSS}>
          <Spinner />
        </Stack>
        :
        <form autoComplete="off" id="myFormAppmonitored" onSubmit={handleSubmit}>
          <InfoDesc desc="basicInfos" />
          {EditBasicTab(true)}
          <Button shape="circular" style={{ display: "none" }} ref={buttonref} type="submit"> Validate </Button>
        </form>
    );

    const editScores = () => (<> {EditScoresTab(true)} </>)

    const editReviews = () => (
      <Stack tokens={{ childrenGap: 20 }}>
        {EditBasicTab(false)}
        {EditScoresTab(false)}
      </Stack>
    );

    (overlayName === 'addMonitoredApp') && setMonitoredOverLayData({
      headerTitle: addTitle, size: "large", isTabs: true,
      tabItems: { Basic: addBasics(), Scores: addScores(), "Review Data": addReviews() }
    });

    Object.keys(formDataBasic).length > 0 && (overlayName === 'editMonitoredApp') && setMonitoredOverLayData({
      headerTitle: editTitle, size: "large", isTabs: true,
      tabItems: { Basic: editBasics(), Scores: editScores(), "Review Data": editReviews() }
    });

  }, [overlayName, formDataBasic, cloneCpuForms, cloneMemForms, cloneNetForms, deviceList, selectedValue, categorySearchData, subCategorySearchData, selectedCategoryOptions, selectedSubCategoryOptions, deviceName, loadingDevice]);

  useEffect(() => {
    if (!overlayOpen) {
      setOverlayName('');
      setSelectedCategoryOptions([]);
      setSelectedSubCategoryOptions([]);
    }
  }, [overlayOpen]);

  useEffect(() => {
    contextValue.setSelectedRowIdInTable([]);
  }, []);

  useEffect(() => {
    contextValue.selectedRowIdInTable.length > 0 ? setDeleteDisabled(false) : setDeleteDisabled(true);
  }, [contextValue.selectedRowIdInTable]);

  const breadcrumbData = (
    <StackItem grow shrink>
      <Stack tokens={{ childrenGap: 5 }} horizontalAlign="start">
        {empty}
        <StackItem grow shrink> <Breadcrumbs items={[{ name: "Automate", link: "/home" }, {  name: "Apps", link: "#" }, { name: "App Monitored", link: "#" }]} /> </StackItem>
      </Stack>
    </StackItem>
  );

  const fullScreen = (
    <StackItem grow shrink>
      <Stack horizontalAlign="end">
        <StackItem grow shrink>
          <FullScreenButton handle={handle} />
        </StackItem>
      </Stack>
    </StackItem>
  );

  const inlineMenu = <SideMenu leftOpenSubMenu={leftOpenSubMenu} setleftOpenSubMenu={setleftOpenSubMenu} menuItems={AutomateAppPages("App Monitored")} />;
  const searchBarData = <SearchBar setCurrentPageNo={setCurrentPageNo} columnSearch={"for Name"} searchVal={searchVal} setSearchVal={setSearchVal} setLoading={setLoading} disabled={loading || tableData.length === 0} />;

  const overflowData = () => {
    const overFlowComponent = () => {
      const addAppsData = () => {
        const permits = permissions.includes("all") || permissions.includes("appMonitored_Fullaccess");
        const handleAddApps = () =>{ setCurrentPageNo(1); setSpinnerLoad(false)}
        const handleOverflow = () => { /* setSelectedCategoryOptions([]); setSelectedSubCategoryOptions([]); */
          setOverlayName('addMonitoredApp');
          setOverlayOpen(true);
          setFormDataBasic({
            Category: '', Subcategory: '', ApplicationName: '', ApplicationType: '', UrlPatterns: [{}], ApplicationBinaries: '',
            cpuUtilisation: [{ cpuFrom: '', cpuTo: '', cpuScore: '', cpuRank: '' }],
            memUtilisation: [{ memFrom: '', memTo: '', memScore: '', memRank: '' }],
            netUtilisation: [{ netFrom: '', netTo: '', netScore: '', netRank: '' }],
          });
        };

        const addAppsEnable = (
          <StackItem onClick={handleOverflow}>
            <Button shape="circular" disabled={loading} appearance="subtle" size="small" onClick={handleAddApps}>
              <Stack tokens={{ childrenGap: 5 }} horizontal>
                <StackItem> <AddSquare20Regular {...(loading ? secondaryIcon : primaryIcon)} /> </StackItem>
                <StackItem> <Caption1> Create Apps </Caption1> </StackItem>
              </Stack>
            </Button>
          </StackItem>
        );

        const addAppsDisable = (
          <StackItem>
            <Tooltip withArrow content="You do not have access" relationship="description" positioning="above">
              <Button shape="circular" appearance="subtle" size="small" disabled>
                <Stack tokens={{ childrenGap: 5 }} horizontal>
                  {empty}
                  <StackItem>
                    <Stack tokens={{ childrenGap: 5 }} horizontal>
                      <StackItem> <AddSquare20Regular {...secondaryIcon} /> </StackItem>
                      <StackItem> <Caption1> Create Apps </Caption1> </StackItem>
                    </Stack>
                  </StackItem>
                </Stack>
              </Button>
            </Tooltip>
          </StackItem>
        );

        return permits ? addAppsEnable : addAppsDisable;
      };

      const dialogBoxData = () => {
        const handleCancel = () => {
          setDeleteAppMonitored(true);
          setCurrentPageNo(1)
        };

        const buttonData = (
          <Button shape="circular" appearance="transparent" size="small" disabled={isdeletedisabled ? true : false}>
            <Stack tokens={{ childrenGap: 5 }} horizontal>
              <StackItem> <Delete20Regular {...(isdeletedisabled ? secondaryIcon : primaryIcon)} /> </StackItem>
              <StackItem> <Caption1> Delete </Caption1> </StackItem>
            </Stack>
          </Button>
        );

        const footerData = (
          <Stack horizontal tokens={{ childrenGap: 10 }}>
            <StackItem> <Button shape="circular" appearance="primary" onClick={handleCancel} size="small"> Confirm </Button> </StackItem>
            <StackItem> <Button shape="circular" size="small"> Cancel </Button> </StackItem>
          </Stack>
        );

        return (
          <StackItem>
            <StackItem>
              <DialogBox content="Kindly verify your intent to remove the app from app monitor" headerButton={buttonData} footer={footerData} />
            </StackItem>
          </StackItem>
        );
      };

      const refreshData = () => {
        const handleRefresh = () => {
          setCurrentPageNo(1);
          setIsRefresh(true);
          setLoading(true)
        };
        return (
          <StackItem>
            <Button shape="circular" disabled={loading} appearance="subtle" size="small" onClick={handleRefresh}>
              <Stack tokens={{ childrenGap: 5 }} horizontal>
                <StackItem> <ArrowClockwise20Regular {...(loading ? secondaryIcon : primaryIcon)} /> </StackItem>
                <StackItem> <Caption1> Refresh </Caption1> </StackItem>
              </Stack>
            </Button>
          </StackItem>
        )
      };

      const exportsData = () => {
        const permits = permissions.includes("all") || permissions.includes("appMonitored_Fullaccess") || permissions.includes("appMonitored_ReadandExport");
        const handleExport = () => { setExportBtnClicked(true); };

        const exportEnable = (
          <>
            <CSVLink id="csv-export-link" data={exportData} filename={`${tenant}_appmonitored_list.csv`}> </CSVLink>
            <Button shape="circular" disabled={loading || tableData.length === 0} appearance="subtle" onClick={handleExport} size="small">
              <Stack tokens={{ childrenGap: 5 }} horizontal>
                <StackItem> <ArrowDownload20Regular {...(loading || tableData.length === 0 ? secondaryIcon : primaryIcon)} /> </StackItem>
                <StackItem> <Caption1> Export </Caption1> </StackItem>
              </Stack>
            </Button>
          </>
        );

        const exportDisable = (
          <Tooltip withArrow content="You do not have access" relationship="description" positioning="above">
            <Button shape="circular" appearance="subtle" size="small" disabled>
              <Stack tokens={{ childrenGap: 5 }} horizontal>
                <StackItem>
                  <Stack tokens={{ childrenGap: 5 }} horizontal>
                    <StackItem> <ArrowDownload20Regular {...secondaryIcon} /> </StackItem>
                    <StackItem> <Caption1> Export </Caption1> </StackItem>
                  </Stack>
                </StackItem>
              </Stack>
            </Button>
          </Tooltip>
        );

        return <StackItem> {permits ? exportEnable : exportDisable} </StackItem>;
      };

      const manageViewData = () => {
        const handleManageView = () => document.getElementById("manageView").click();
        return (
          <StackItem>
            <Button shape="circular" disabled={loading || tableData.length === 0} appearance="subtle" size="small" onClick={handleManageView}>
              <Stack tokens={{ childrenGap: 5 }} horizontal>
                <StackItem> <Settings20Regular {...(loading || tableData.length === 0 ? secondaryIcon : primaryIcon)} /> </StackItem>
                <StackItem> <Caption1> Manage View </Caption1> </StackItem>
              </Stack>
            </Button>
          </StackItem>
        );
      };

      return {
        data:
          <>
            {addAppsData()}
            <StackItem> <Divider vertical /> </StackItem>
            {dialogBoxData()}
            <StackItem> <Divider vertical /> </StackItem>
            {refreshData()}
            {exportsData()}
            {manageViewData()}
            {fullScreen}
          </>
      }
    };
    return (
      <StackItem>
        <OverflowSetCustomExample overlayOpen={overlayOpen} setOverlayOpen={setOverlayOpen} component={overFlowComponent()} />
        <Divider />
      </StackItem>
    )
  };

  const menuDropdownData = () => {
    const handleFilter = () => setFilterMenuOpen(true);
    const handleApply = () => {
      handleFilterArray();
      setFilterMenuOpen(false);
    };
    const handleCancel = () => {
      setFilterMenuOpen(false);
      setDropDownValue1('');
      setDropDownValue2('');
    };
    const handleFilterNew = (newValue: any) => {
      setDropDownValue1(newValue);
      setDropDownValue2('');
    };

    const disableApply = (!dropDownValue1 || !dropDownValue2 || filterArray.some(filter => filter.startsWith(`${dropDownValue1}:`)));

    const menuButton = (
      <MenuButton disabled={loading || tableData.length === 0} shape="circular" size="small" onClick={handleFilter}>
        <Stack tokens={{ childrenGap: 5 }} horizontal>
          <Filter20Filled {...(loading || tableData.length === 0 ? secondaryIcon : primaryIcon)} />
          <Body1> Filter </Body1>
        </Stack>
      </MenuButton>
    );

    const menuItemVal = (
      <>
        <Body1Strong> Add a Filter </Body1Strong>
        <Divider />
        <MenuList>
          <Stack tokens={{ childrenGap: 5 }}>
            <StackItem> <Text /> </StackItem>
            <StackItem> <Caption1> Filter </Caption1> </StackItem>
            <DropdownComponent optionData={filterColumnsData} setDropDownValue={handleFilterNew} dropDownvalue={dropDownValue1} />
            <StackItem> <Divider /> </StackItem>
            <StackItem> <Caption1> Value </Caption1> </StackItem>
            {dropDownValue1 == "Category" && <DropdownComponent optionData={categoryFilterData} setDropDownValue={setDropDownValue2} dropDownvalue={dropDownValue2} />}
            {dropDownValue1 == "Subcategory" && <DropdownComponent optionData={subCategoryFilterData} setDropDownValue={setDropDownValue2} dropDownvalue={dropDownValue2} />}
            {(dropDownValue1 == "Name" || dropDownValue1 == "URL") && <Input size='small' onChange={inputChange} name="filter" value={dropDownValue2} />}
            {dropDownValue1 == "Desktop Binaries" && <Input size='small' onChange={inputChange} name="filter" value={dropDownValue2} />}
            {dropDownValue1 == "Score" && <Input size='small' onChange={inputChange} name="filter" value={dropDownValue2} />}
            <StackItem> <Divider /> </StackItem>
            <Stack tokens={{ childrenGap: 10 }} horizontal>
              <StackItem>
                <Button shape="circular" appearance="primary" onClick={handleApply} disabled={disableApply}> <Caption1> Apply </Caption1> </Button>
              </StackItem>
              <StackItem> <Button shape="circular" onClick={handleCancel}> <Caption1> Cancel </Caption1> </Button> </StackItem>
            </Stack>
          </Stack>
        </MenuList>
      </>
    );

    return <StackItem> <MenuDropdown open={filterMenuOpen} btn={menuButton} itemVal={menuItemVal} /> </StackItem>;
  };

  const resetFiltersData = () => {
    const handleClick = () => {
      setFilterArray([]);
      setIsFilter(false);
      setDropDownValue2('');
      setResetDisabled(true);
    };
    return (
      <StackItem onClick={handleClick}>
        <Button shape="circular" appearance="subtle" size="small" disabled={isResetDisabled}>
          <Stack tokens={{ childrenGap: 5 }} horizontal>
            <StackItem> <FilterDismiss20Filled /> </StackItem>
            <StackItem> <Caption1> Reset Filters </Caption1> </StackItem>
          </Stack>
        </Button>
      </StackItem>
    );
  };

  const paginationData = (tableData.length > 0 && !loading) && <StackItem> <Pagination setLoading={setLoading} totalPages={totalPages} currentPageNo={currentPageNo} setCurrentPageNo={setCurrentPageNo} /> </StackItem>;

  const filterTags = () => (
    <StackItem>
      <Stack wrap horizontal>
        {filterArray.length > 0 && filterArray.map((item, index) => (
          <Button shape="circular" size="small">
            <Stack tokens={{ childrenGap: 5 }} horizontal>
              <StackItem> {item.includes("00:00") ? item.split("00:00")[0].trim() : item} </StackItem>
              <StackItem>
                <Stack tokens={{ childrenGap: 1 }}>
                  {empty}
                  <StackItem> <Dismiss16Regular onClick={() => { handleCloseFilter(index) }} /> </StackItem>
                </Stack>
              </StackItem>
            </Stack>
          </Button>
        ))}
      </Stack>
    </StackItem>
  );

  const resultData = (
    <StackItem disableShrink>
      {(tableData.length > 0 && !loading) && (totalRecords > 0) &&
        <Caption1>
          Showing {((currentPageNo - 1) * 50) + 1} to {(currentPageNo * 50) > totalRecords ? totalRecords : (currentPageNo * 50)} of {totalRecords} Records
        </Caption1>
      }
    </StackItem>
  );

  const mainOverlay = <OverLay isNavBtn={true} overlayopen={overlayOpen} setOverlayOpen={setOverlayOpen} saveBtnFunc={setSaveBtnClicked} overlayData={monitoredOverLayData} handleOutsideButton={() => buttonref?.current?.click()} />;

  const appMonitoredData = () => {
    const mainTableData = () => {
      return loading
        ? <SkeletonDataTable />
        : (tableData.length > 0)
          ? <DataTable tableData={tableData} columns={tableColumnsData} />
          : (
            <Stack horizontalAlign="center" tokens={{ childrenGap: 15, padding: 10 }}>
              <StackItem> <Text size={500}> No result. </Text> </StackItem>
            </Stack>
          );
    };

    const overlayForm = (
      <TroubleshooterDevice_fun data={final_data1} func={set_final_data1} pageNo={(currentPageNo - 1) * 10} setTotalPages={setTotalPages} setTotalRecords={setTotalRecords} groupName={deviceName} setGroupName={setDeviceName} setallDevice={setallDevice} groupData={deviceList} groupFunc={setDeviceList} setTotalOverlayRecords={setTotalOverlayRecords} setTotalOverlayPages={setTotalOverlayPages} />
    );

    const renderTable = (extraProps = {}) => (
      <App_Monitored_Func data={final_data} func={set_final_data} searchVal={searchVal} pageNo={(currentPageNo - 1) * 50} setTotalPages={setTotalPages} setTotalRecords={setTotalRecords} setDeleteDisabled={setDeleteDisabled} deleteAppMonitored={deleteAppMonitored} setDeleteAppMonitored={setDeleteAppMonitored} setOverlayOpen={setOverlayOpen} setFormData={setFormDataBasic} formdata={formDataBasic} overlayName={overlayName} saveBtnClicked={saveBtnClicked} setsaveBtnClicked={setSaveBtnClicked} isRefresh={isRefresh} setIsRefresh={setIsRefresh} setRefreshToast={setRefreshToast} deviceName={deviceName} isFilter={isfilter} dropDownValue1={dropDownValue1} setIsFilter={setIsFilter} dropDownValue2={dropDownValue2} filterArray={filterArray} setErrorToast={setErrorToast} setToastMessage={setToastMessage} setIsToast={setIsToast} setSpinnerLoad={setSpinnerLoad} setLoading={setLoading} setExportBtnClicked={setExportBtnClicked} exportBtnClicked={exportBtnClicked} scoresFormData={scoresFormData} setExportDetails={setExportDetails} {...extraProps}   />
    );

    const { tableAdd, tableEdit } = {
      tableAdd: { rowID }, tableEdit: { rowID, setDeviceName, setallDevice, setSelectedCategoryOptions, setSelectedSubCategoryOptions }
    };

    return (
      <>
        {mainTableData()}
        {overlayOpen && overlayForm}
        {renderTable(saveBtnClicked ? (overlayName !== '' ? tableAdd : {}) : (overlayName === 'editMonitoredApp' ? tableEdit : {}))}
      </>
    );
  };

  const appMonitoredToast = () => (
    <>
      {isToast && <ToastComponent setmessagebar={setIsToast} toastIntent="success" position="top-end" title="Success" footer="" message={(!saveBtnClicked && overlayName === '') ? "Monitored App Deleted Successfully" : overlayName === 'addMonitoredApp' ? "New Monitoring App Created Successfully" : "App Monitor Updated Successfully"} isToastEnabled={isToast} />}
      {refreshToast && <ToastComponent setmessagebar={setIsToast} toastIntent="success" position="top-end" title="Success" footer="" message="Data Table Refreshed" isToastEnabled={refreshToast} />}
      {errorToast && <ToastComponent setmessagebar={setErrorToast} toastIntent="error" position="top-end" title="Failed" footer="" message={toastMessage} />}
    </>
  );

  return (
    <FullScreen handle={handle} className="fullScreenBackgroundColor">
      <StackItem grow shrink style={BreadcrumbsBorder}>
        <Stack tokens={{ childrenGap: 10 }} horizontal>
          {breadcrumbData}
        </Stack>
      </StackItem>
      <Stack style={SubSectionResponsive} tokens={{ childrenGap: 20 }} horizontal>
        <StackItem style={DynamicBoxingCSS}>
          <Stack style={DynamicBoxingCSS}>
            <FluentProvider style={parentHome} theme={dashboardTheme}>
              <Stack style={parentHome} horizontal>
                {inlineMenu}
                <StackItem style={DynamicBoxingCSS}>
                  <Stack style={parentHome} tokens={{ childrenGap: 10 }}>
                    {overflowData()}
                    <StackItem style={wraperStyle}>
                      <StackItem>
                        <Stack horizontalAlign="space-between" wrap horizontal tokens={{ childrenGap: 10 }}>
                          <Stack horizontal tokens={{ childrenGap: 10 }}>
                            <StackItem>
                              {searchBarData}
                            </StackItem>
                            {menuDropdownData()}
                            {resetFiltersData()}
                          </Stack>
                          {paginationData}
                        </Stack>
                        <Stack horizontal horizontalAlign="space-between" tokens={{ padding: '10px 0px 0px 0px' }}>
                          {filterTags()}
                          {resultData}
                        </Stack>
                      </StackItem>
                      <InfoDesc desc="inform" />
                    </StackItem>
                    {appMonitoredData()}
                  </Stack>
                </StackItem>
              </Stack>
            </FluentProvider>
          </Stack>
          {mainOverlay}
          {appMonitoredToast()}
        </StackItem>
        {empty}
      </Stack>
    </FullScreen>
  );
};
